import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-panel" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = {
  key: 0,
  class: "modal-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "modal-empty"
}
const _hoisted_6 = {
  key: 2,
  class: "movements-list"
}
const _hoisted_7 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}
const _hoisted_8 = {
  key: 1,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}
const _hoisted_9 = {
  key: 2,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}
const _hoisted_10 = { class: "mov-info" }
const _hoisted_11 = { class: "mov-meta" }
const _hoisted_12 = { class: "mov-date" }
const _hoisted_13 = {
  key: 0,
  class: "mov-user"
}
const _hoisted_14 = {
  key: 0,
  class: "mov-notes"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "modal-overlay",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, "Histórico: " + _toDisplayString(_ctx.itemName), 1),
          _createElementVNode("button", {
            class: "modal-close",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5"
            }, [
              _createElementVNode("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
              }),
              _createElementVNode("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
              })
            ], -1)
          ]))])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Carregando histórico..."))
          : (_ctx.movements.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("svg", {
                  width: "32",
                  height: "32",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.4"
                }, [
                  _createElementVNode("path", { d: "M5 12h14M12 5l7 7-7 7" })
                ], -1),
                _createTextVNode(" Nenhuma movimentação registrada. ", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movements, (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: m.id,
                    class: "movement-row"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["mov-type-badge", _ctx.movTypeClass(m.movementType)])
                    }, [
                      (m.movementType === 'saida')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("path", { d: "M5 12h14M12 5l7 7-7 7" }, null, -1)
                          ]))]))
                        : (m.movementType === 'entrada-nf')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[5] || (_cache[5] = [
                              _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }, null, -1),
                              _createElementVNode("polyline", { points: "14 2 14 8 20 8" }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[6] || (_cache[6] = [
                              _createElementVNode("path", { d: "M19 12H5M12 19l-7-7 7-7" }, null, -1)
                            ]))])),
                      _createTextVNode(" " + _toDisplayString(_ctx.movTypeLabel(m.movementType)), 1)
                    ], 2),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["mov-qty", m.movementType === 'saida' ? 'mov-qty--out' : 'mov-qty--in'])
                      }, _toDisplayString(m.movementType === 'saida' ? '-' : '+') + _toDisplayString(m.quantity), 3),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatDate(m.movedAt)), 1),
                        (m.movedBy)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "· " + _toDisplayString(m.movedBy), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (m.notes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(m.notes), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
      ])
    ])
  ]))
}